import { Pagination  } from "@/components/shared";
import { DataTable } from "@/components/shared/table";
import { useRef } from "react";
import { getColumns } from "./columns";
import { useIntl } from "react-intl";
import { useTranslation } from "react-i18next";
import TendersFilter from "./TendersFilter";
import { GetPaginatedTendersQuery, GetPaginatedTendersQueryVariables, Tender, TenderEdge, GetPaginatedTendersDocument } from "@/graphql/__generated__/graphql";
import { useNavigate } from "react-router-dom";

interface PaginationRef {
  triggerHandleFilterSubmit: (_newVariables: Partial<GetPaginatedTendersQueryVariables>) => void;
}

const Tenders = () => {

  // Ref use for Scroll To Top
  const scrollRef = useRef<HTMLDivElement>(null);

  // Pagination config
  const paginationRef = useRef<PaginationRef | null>(null);
  const paginationName = "paginatedTenders";

  // Hooks
  const intl = useIntl();
  const navigate = useNavigate();
  const { t } = useTranslation(["translation", "tables", "common"]);

  const onFilterSubmit = (variables: GetPaginatedTendersQueryVariables) => {
    // When the filter is submitted in the PageComponent,
    // this will call the handleFilterSubmit inside Pagination.
    paginationRef.current?.triggerHandleFilterSubmit(variables);
  };

  /**
   * OnClick handler for the edit button. Navigate to the Edit Tender page
   * @param tender: typeof Tender
   */
  const handleOnClickEditTender = (tender: Tender) => {
    if (!tender) return;
    navigate(`/tender/${tender.id}`);
  };

  return (
    <div className="h-0 grow">
      <div ref={scrollRef} className="st-table-container mt-6 overflow-visible mb-32">
        {/* Tenders table */}
        <Pagination<TenderEdge, GetPaginatedTendersQuery, GetPaginatedTendersQueryVariables>
          ref={paginationRef} props={{ queryDocument: GetPaginatedTendersDocument, paginationName, className: "mx-6 mb-4" }}>
          {(dataSlice, loading, displayAmount) => (
            <>
              {/* Tenders filter */}
              <div className="mx-6">
                <TendersFilter onFilterSubmit={onFilterSubmit} displayAmount={displayAmount as number} />
                <DataTable
                  disableSorting={false}
                  disableRowColour={true}
                  loading={loading}
                  clickableRows={true}
                  displayAmount={displayAmount as number}
                  data={dataSlice.map(edge => edge.node) ?? []}
                  columns={getColumns(intl, t, handleOnClickEditTender, navigate)}
                  onRowClick={handleOnClickEditTender}
                  className="max-h-[calc(100vh-14rem)]"
                />
              </div>
            </>
          )}
        </Pagination>
      </div>
    </div>
  );
};

export default Tenders;
